<template>
    <grid
        ref="grid"
        class="work-orders-vendor-manager"
        :columnDefs="columnDefs"
        :fetchCallback="fetchCallback"
    >
        <busy-modal :show="busy" :overlay="true"></busy-modal>
        <div class="work-orders-vendor-manager__toolbar">
             <responsive-button
                :icon="['fas', 'file-excel']"
                :href="exportExcelHref"
                @click="generatingExcelReportSuccessToast"
                variant="primary"
                ></responsive-button
            >
            <responsive-button
                :icon="['fas', 'arrows-rotate']"
                @click="refresh"
                variant="primary"
                >Refresh</responsive-button
            >
            <responsive-button
                :icon="['fas', 'plus']"
                variant="primary"
                @click="openAddNewModal"
                v-if="hasConfigAccess"
                >Add New Vendor</responsive-button
            >
           
        </div>
    </grid>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters } from 'vuex';
    import API from '../../../api';
    import Grid from '../../generic/grid/grid.vue';
    import Page from '../../generic/page/page.vue';
    import Modal from '../../generic/modal/modal.vue';
    import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';
    import ActionsCellRenderer from './actions-cell-renderer.vue';
    import BusyModal from '../../generic/busy-modal/busy-modal.vue';

    export default {
        name: 'WorkOrdersVendorManagerGrid',
        components: {
            Modal,
            Grid,
            ResponsiveButton,
            BusyModal,
            actionsCellRenderer: ActionsCellRenderer,
        },
        data() {
            return {
                offset: 0,
                limit: 20,
                sort: 'id',
                desc: true,
                search: '',
                busy: false,
                columnDefs: [
                    {
                        field: 'id',
                        headerName: 'ID',
                        maxWidth: 80,
                    },
                    {
                        field: 'company',
                        headerName: 'Company Name',
                        flex: 1,
                    },
                    {
                        field: 'first_name',
                        headerName: 'First Name',
                        flex: 0,
                    },
                    {
                        field: 'last_name',
                        headerName: 'Last Name',
                        flex: 0,
                    },
                    {
                        field: 'email',
                        headerName: 'Email',
                        flex: 0,
                    },
                    {
                        field: 'mobile_phone',
                        headerName: 'Mobile Phone',
                        flex: 0,
                    },
                    {
                        field: 'specialty',
                        headerName: 'Specialty',
                        flex: 0,
                    },
                    {
                        headerName: '',
                        minWidth: 130,
                        maxWidth: 130,
                        resizable: false,
                        sortable: false,
                        cellStyle: { textAlign: 'center' },
                        cellRenderer: 'actionsCellRenderer',
                        cellRendererParams: {
                            modalData: {
                                onDelete: this.onDelete,
                            },
                        },
                    },
                ],
            };
        },
        computed: {
            ...mapGetters('header', ['userUnicodeDateFormat']),
            ...mapGetters('workOrders', ['metadata']),
            exportExcelHref() {
                return encodeURI(
                    `/app/work-orders/api/vendors/grid/excel/?offset=${this.offset}&limit=${this.limit}&sort=${this.sort}&desc=${this.desc}&search=${this.search}`
                );
            },
            hasConfigAccess() {
                return (
                    this.metadata.permissions &&
                    this.metadata.permissions.has_config_access
                );
            },
            fetchCallback() {
                return ({ offset, limit, sort, desc, search }) => {
                    this.offset = offset;
                    this.limit = limit;
                    this.sort = sort;
                    this.desc = desc;
                    this.search = search;

                    return API.get(`/app/work-orders/api/vendors/grid/`, {
                        params: {
                            offset,
                            limit,
                            sort,
                            desc,
                            search,
                        },
                    });
                };
            },
        },
        methods: {
            openAddNewModal() {
                this.$router.push({
                    name: 'Work Order - Vendor Create',
                });
            },
            async onDelete(item) {
                try {
                    this.busy = true;
                    await API.delete(
                        `/app/work-orders/api/vendors/${item.id}/`
                    );
                } catch (e) {
                    this.errorToast({text: `Could not delete vendor '${item.company || item.id}'.`})
                } finally {
                    this.busy = false;
                    this.refresh();
                }
            },
            refresh() {
                this.$refs.grid.refreshDataSource();
            },
        },
    };
</script>

<style scoped lang="scss"></style>
